export class ConditionEditorHelper {

    /**
     * Instance of the Codemirror editor
     */
    private readonly editor = undefined;

    constructor(editor) {
        this.editor = editor;
    }

    /**
     * Format and indent the editor content
     */
    formatAndIndent() {
        this.editor.setValue(this.format(this.editor.getValue()));
        this.indent();
    }

    /**
     * Reindent the editor's content
     */
    indent() {
        for (let i = 0; i < this.editor.lineCount(); i++) {
            this.editor.indentLine(i);
        }
    }

    /**
     * Format the equation (no indentation)
     */
    format(code: string) {
        let result = '';

        const orSplitted = code.split('||');
        let index = 1;
        for (const element of orSplitted) {
            const splittedElement = element.replaceAll(';', ' || ')
            .replaceAll('=', ' = ').replaceAll('&&', '\n&&\n');

            result += '( ' + splittedElement + ' )\n';
            if (index < orSplitted.length) {
                result += '||\n';
            }
            index++;
        }

        return result;
    }
}
